import Sidepanel from './Sidepanel'

export default Sidepanel
